import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'EMPLOYEE_PROFILE';

export const {action: employeeChanged} = createAction(`${domain}/EMPLOYEE_CHANGED`, index => index);
